import { AggregatedError } from "@otto-ec/assets-core-utils/nano-effect";
import { captureError, type APMLabelsMap, type ApmDefaultLabels } from "@otto-ec/global-resources/apm";

interface CaptureErrorArgs {
	message: string;
	type: string;
	/*                                                                      */
	labels: ApmDefaultLabels;
	/*                                                                                       */
	custom?: APMLabelsMap;
	/*                                                                                                         */
	payload?: unknown;
}

export function normalizeError(error: unknown): string {
	if (error instanceof AggregatedError) {
		return error.errors.join(", ");
	} else if (typeof error === "string") {
		return error;
	} else if (typeof error === "number") {
		return error.toString();
		/*                                                                                                    */
	} else if (error instanceof Error) {
		return `${error.name}: ${error.message}`;
	} else {
		return "unknown error";
	}
}

export function captureErrorWithPayload({ message, type, labels, custom = {}, payload }: CaptureErrorArgs): void {
	const genericError = new Error(message);
	const options = {
		type,
		custom,
	};

	if (payload) {
		options.custom.message_or_status_codes = normalizeError(payload);
	}

	captureError(genericError, labels, options);
}
